<div class="routing-container">
    <app-information-note
        *ngIf="showServiceTypeWarning && (pageMode === modeIcons.add || pageMode === modeIcons.edit)"
        [message]="chooseServiceTypeBeforeAddingRoutingCriteria"
        [isFrom]="'apInvoiceFetchFromSFTP'"
        [mode]="'warning'">
    </app-information-note>
    <div class="table-tabs-container">
        <div class="table-tabs-header">
            <div class="table-tabs-title ibc-heading-h7-bold-subtitle">
                <span class="table-tab-name">Routing Criteria</span>
            </div>
            <div class="tab-icons">
                <app-svg-icon
                    [list]="routingTableHeaderIcons"
                    class="icon-section"
                    (iconClicked)="onRoutingIconTabClicked($event)"></app-svg-icon>
            </div>
        </div>
        <div class="tab-content-container">
            <app-create-edit-table
                class="create-edit-table"
                [crudTableDataSource]="routingTableDataSource"
                [crudTableData]="routingTableData"
                [crudTableCustomizeConfig]="routingCustomizeColumnsConfig"
                [isFrom]="tableName.accountRoutingCriteria"
                [formConfig]="routingFormConfig"
                [pageMode]="pageMode"
                [allowedServiceTypes]="selectedGovtServiceTypes"
                (selectionTableChange)="onRoutingTableSelectionChange($event)"
                (crudTableFormValue)="onRoutingFormChange($event)">
            </app-create-edit-table>
        </div>
    </div>
</div>
